<template>
  <div>
    <div class="bl-find-search1">
      <advertisement :option="identity == 'product' ? $config.advertisement.horizontal.productSeachList : $config.advertisement.horizontal.actorSeachList" :width="'100%'"></advertisement>
      <div class="bl-find-search1Div">
        <div class="bl-find-search__block">
          <div class="bl-find-search__input">
            <el-input :placeholder="$t('finds.searchVisitor')" v-if="identity === 'person'" v-model="query.searchKeywords" clearable></el-input>
            <el-input :placeholder="$t('finds.searchProduct')" v-if="identity === 'product'" v-model="query.searchKeywords" clearable></el-input>
            <el-input :placeholder="$t('finds.searchActor')" v-if="identity === 'actor'" v-model="query.searchKeywords" clearable></el-input>
          </div>
          <el-button type="primary" :loading="loading" class="bl-find-search__btn" @click="searchList('keyword')">{{ $t('common.search') }}</el-button>
        </div>
        <div class="bl-find-search__help" v-if="false">
          <template v-if="keywordList.pageList && keywordList.pageList.length > 0">
            <span>{{ $t('common.returnsApplication') }}：</span>
            <a v-for="item in keywordList.pageList" :key="item.id" @click="keywordClick(item)">{{ item.keyword }}</a>
            <i class="el-icon-refresh-left bl-find-search__refresh" v-if="pages2 > 1" @click="keywordRefresh()"></i>
          </template>
        </div>
      </div>
    </div>
    <div class="bl-find-condition" v-loading="loading2">
      <div class="bl-find-condition__head">
        <div class="bl-container">
          <div class="tag-search-block">
          <TagSearch
            v-if="questionSite.questionList && questionSite.questionList.length > 0"
            :questionSite="questionSite"
            :questionListValue.sync="questionListValue"
            @searchList="searchList('find')" />
          </div>
          <div class="bl-find-r-page1">
            <template v-if="identity == 'actor'">
              <label @click="changeSort(sort, 'EXHIBITOR_UNIQUE_VISITOR', 1)" class="v-sort-1" :class="{ desc: sort == 'desc', asc: sort == 'asc' }"
                ><span>{{ $t('finds.attention') }}</span
                ><i class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i
              ></label>
              <label @click="changeSort(sort2, 'EXHIBITOR_ADVERTS_VIDEO', 2)" class="v-sort-1" :class="{ desc: sort2 == 'desc', asc: sort2 == 'asc' }"
                ><span>{{ $t('finds.video') }}</span
                ><i class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i
              ></label>
              <label @click="changeSort(sort3, 'EXHIBITOR_INITIAL', 3)" class="v-sort-1" :class="{ desc: sort3 == 'desc', asc: sort3 == 'asc' }"
                ><span>{{ $t('finds.spell') }}</span
                ><i class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i
              ></label>
            </template>
            <template v-if="identity == 'product'">
              <label @click="changeSort(sort, 'PRODUCT_PAGE_VIEW', 1)" class="v-sort-1" :class="{ desc: sort == 'desc', asc: sort == 'asc' }"
                ><span>{{ $t('finds.popularity') }}</span
                ><i class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i
              ></label>
              <label @click="changeSort(sort2, 'PRODUCT_VIDEO_URL', 2)" class="v-sort-1" :class="{ desc: sort2 == 'desc', asc: sort2 == 'asc' }"
                ><span>{{ $t('finds.video') }}</span
                ><i class="el-icon-caret-top"></i><i class="el-icon-caret-bottom"></i
              ></label>
            </template>
            <template v-if="dataList.length > 0">
              <div class="page-acount" v-if="identity == 'actor'">
                {{ $t('finds.common') }}<span>{{ query.total }}</span
                >{{ $t('finds.condition') }}
              </div>
              <div class="page-go">
                <i class="el-icon-arrow-left" :class="{ disabled: query.pageNum == 1 }" @click="pagePrev"></i>
                <span>{{ query.pageNum }}<font>/</font>{{ pages }}</span>
                <i class="el-icon-arrow-right" :class="{ disabled: query.pageNum == pages }" @click="pageNext"></i>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="bl-find-list" ref="result-list">
      <div class="bl-container text-center" v-if="identity != 'person'">
        <div class="search-nav">
          <span class="s1" :class="{ active: identity === 'actor' }" @click="changeSearchActive('actor')">{{ $t('exhibitors') }}</span>
          <span class="s2" :class="{ active: identity === 'product' }" @click="changeSearchActive('product')">{{ $t('exhibits') }}</span>
        </div>
      </div>
      <div class="bl-container" v-loading="loading">
        <el-row :gutter="30">
          <template v-if="identity == 'actor'">
            <el-col :span="8" v-for="(item, index) in dataList" :key="item.visitorId">
              <ExhibitorCard
                @collect="collectEvent_a"
                @invite="inviteEvent_a"
                @details="detailsEvent"
                @msg="message_a"
                @live="live_a"
                :vData="item"
                :index="index"
              ></ExhibitorCard>
            </el-col>
          </template>
          <template v-else-if="identity == 'product'">
            <el-col :xs="6" :sm="6" :md="6" v-for="(item, index) in dataList" :key="item.visitorId">
              <ExhibitCard @callback="vExibitsCallback" :vData="item" :index="index" v-if="identity === 'product'" />
            </el-col>
          </template>
          <template v-else>
            <el-col :xs="8" :sm="8" :md="8" v-for="(item, index) in dataList" :key="item.visitorId">
              <VisitorCard
                showType="find"
                :index="index"
                :vData="item"
                @collect="collectEvent_p"
                @invite="inviteEvent"
                @details="detailsEvent"
                @msg="msgEvent"
                v-if="identity == 'person'"
              />
            </el-col>
          </template>
        </el-row>
        <hNoData v-if="dataList.length == 0"></hNoData>
      </div>
      <div class="bl-container">
        <el-pagination
          v-if="dataList.length > 0"
          background
          @current-change="handleCurrentChange"
          :page-size="query.pageRows"
          :current-page.sync="query.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="query.total"
          class="bl-page"
        >
        </el-pagination>
        <advertisement class="bl-container margin-t-24" :option="identity == 'product' ? $config.advertisement.horizontal.productBottom : $config.advertisement.horizontal.actorBottom" :width="'100%'" :height="'190px'"></advertisement>
      </div>
    </div>
    <ChatWithExhibitor @invite="submitInvite" :action="action" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
// getExhibitorSearchList
import { 
  getSearchTrendInfo, 
  searchVisitorList, 
  recommendProductList, 
  getRecommendedExhibitorsList 
} from '@/api/find'
import { getProductTags } from '@/api/index'
import { eventMixin } from '@/mixins/event.js'
import { scrollToY } from '@/utils/function.js'
import { inviteMixin } from '@/mixins/inviteEvent.js'
import commonMixin from '@/mixins/common.js'
import hNoData from '@/components/hNoData'
import TagSearch from '@/components/TagSearch'
import VisitorCard from '@/components/card/VisitorCard'
import ExhibitCard from '@/components/card/ExhibitCard'
import ExhibitorCard from '@/components/card/ExhibitorCard.vue'
import advertisement from '@/components/advertisement'

/**
 * 点击搜索，保存搜索条件
 */
export default {
  name: 'searchList',
  mixins: [eventMixin, inviteMixin, commonMixin],
  components: {
    VisitorCard,
    ExhibitCard,
    ExhibitorCard,
    hNoData,
    advertisement,
    TagSearch
  },
  data() {
    return {
      sort: '',
      sort2: '',
      sort3: '',
      sortField: 'recommend_custom_letter_asc',
      loading: false,
      loading2: false,
      kQuery: {
        pageNum: 1,
        pageRows: 8,
        total: 0
      },
      query: {
        pageNum: 1,
        pageRows: this.$route.params.type == 'actor' ? 18 : 9,
        total: 0,
        searchKeywords: this.$route.query.keyword
      },
      dataList: [],
      questionSite: {},
      questionListValue: [],
      keywordList: {},
      listType: '',
      identity: '',
      isFirstEnter: false // 是否第一次进入
    }
  },
  computed: {
    ...mapGetters(['exhibitorId', 'subjectType']),
    pages: function() {
      if (this.query.total == 0) return 0
      let y = this.query.total % this.query.pageRows
      if (y == 0) {
        return this.query.total / this.query.pageRows
      } else {
        return parseInt(this.query.total / this.query.pageRows) + 1
      }
    },
    pages2: function() {
      if (this.kQuery.total == 0) return 0
      let y = this.kQuery.total % this.kQuery.pageRows
      if (y == 0) {
        return this.kQuery.total / this.kQuery.pageRows
      } else {
        return parseInt(this.kQuery.total / this.kQuery.pageRows) + 1
      }
    },
    ...{
      iType: function() {
        if (this.identity == 'person') return 'VISITOR'
        if (this.identity == 'product') return 'PRODUCT'
        if (this.identity == 'actor') return 'ACTOR'
      }
    }
  },
  mounted() {
    this.pageInit()
    window.PC.$RangersEventList('view', null, this.identity)
  },
  methods: {
    pageInit() {
      if (this.subjectType == 'VISITOR' || !this.subjectType) {
        this.identity = 'actor'
      } else {
        this.identity = 'person'
      }
      this.getProductTags()
      this.getSearchTrendInfo()
      this.fetchDataList()
    },
    // 切换展商，展品
    changeSearchActive(type) {
      this.identity = type
      this.sort = ''
      this.sort2 = ''
      this.sortField = 'recommend_custom_letter_asc'
      this.query.pageNum = 1
      window.PC.$RangersEventList('view', null, this.identity)
      this.getProductTags()
      this.searchList()
    },
    // 展品卡片回调
    vExibitsCallback(eData) {
      switch (eData.type) {
        case 'message':
          this.message_a(eData.data)
          break
        case 'invite':
          if (eData.data.invite) return
          this.inviteEventExh(eData.data, eData.index, 'products')
          break
        case 'details':
          this.detailsEvent(eData.data)
          break
        case 'collect':
          this.collectEvent(
            {
              id: eData.data.collectionId,
              deleted: eData.data.collected,
              collectionSubjectType: this.iType,
              collectionSubjectId: eData.data.id
            },
            eData.index
          )
          break
        case 'live':
          this.live_a(eData.data)
          break
      }
    },
    // 更新收藏状态
    updateCollect(status, index) {
      this.dataList[index]['collected'] = status
    },
    // 更新邀约状态
    updateInvite(status, index) {
      this.dataList[index]['invite'] = status
    },
    // 页码 change
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.fetchDataList()
      scrollToY(0, 10)
    },
    // 搜索展品列表
    fetchProductList(questionList) {
      this.query.pageRows = 24
      if (this.listType === 'search') {
        this.loading = true
      }
      recommendProductList({
        ...this.query,
        questionList,
        showType: 'PRODUCT_LIST',
        productSort: this.sortField
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 || res.data) {
            let data = res.data
            this.query.total = data.total || 0
            this.query.pages = data.pages || 0
            this.dataList = data.list || []
            if (this.listType === 'search') {
              this.$nextTick(() => {
                scrollToY(this.$refs['result-list'].offsetTop - 130)
              })
            }
          } else {
            this.dataList = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 搜索展商列表
    fetchActorList(questionList) {
      this.query.pageRows = 18
      if (this.listType === 'search') {
        this.loading = true
      }
      getRecommendedExhibitorsList({
        ...this.query,
        questionList,
        showType: 'ACTOR_LIST',
        exhibitorSort: this.sortField
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000 || res.data) {
            let data = res.data
            this.query.total = data.total || 0
            this.query.pages = data.pages || 0
            this.dataList = data.list || []
            if (this.listType === 'search') {
              this.$nextTick(() => {
                scrollToY(this.$refs['result-list'].offsetTop - 130)
              })
            }
          } else {
            this.dataList = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取列表
    fetchDataList(questionList) {
      if (this.listType == 'search' && this.identity == 'person') {
        this.searchList('search')
        return false
      }
      this.loading = true
      questionList = questionList || this.questionListValue
      switch (this.identity) {
        case 'product':
          this.fetchProductList(questionList)
          break
        case 'actor':
          this.fetchActorList(questionList)
          break
      }
    },
    // 搜索
    searchList(type) {
      this.listType = 'search'
      this.loading = true
      let questionList = this.questionListValue
      if (type === 'keyword') {
        window.PC.$RangersEventList(type, this.query.searchKeywords, this.identity)
      }
      if (type === 'find') {
        window.PC.$RangersEventList(type, questionList, this.identity)
      }
      if (type != 'search') {
        this.kQuery.pageNum = 1
        this.query.pageNum = 1
      }

      switch (this.identity) {
        case 'person':
          // 搜索客商
          searchVisitorList({
            ...this.query,
            questionList,
            showType: 'PERSON_LIST'
          })
            .then(res => {
              return res.data
            })
            .then(res => {
              if (res.code == 1000) {
                let data = res.data
                this.query.total = data.total || 0
                this.query.pages = data.pages || 0
                this.dataList = data.list || []
              }
            })
            .finally(() => {
              this.loading = false
            })
          break
        default:
          // 搜索 展品/展商
          this.fetchDataList(questionList)
          break
      }
    },
    // 获取标签列表
    getProductTags() {
      let showType = ''
      switch (this.identity) {
        // 客商列表
        case 'person':
          showType = 'PERSON_LIST'
          break
        // 展品列表
        case 'product':
          showType = 'PRODUCT_LIST'
          break
        // 展商列表
        case 'actor':
          showType = 'ACTOR_LIST'
          break
      }

      this.loading2 = true

      getProductTags({
        showType
      })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            this.questionSite = res.data
          }
        })
        .finally(() => {
          this.loading2 = false
        })
    },
    // 关键词接口
    getSearchTrendInfo() {
      getSearchTrendInfo({ ...this.kQuery })
        .then(res => {
          return res.data
        })
        .then(res => {
          if (res.code === 1000) {
            this.keywordList = res.data
            this.kQuery.total = res.data.totalCount
          }
        })
    },
    // 关键词点击
    keywordClick(data) {
      this.query.searchKeywords = data.keyword
    },
    // 关键词刷新
    keywordRefresh() {
      let n = this.kQuery.pageNum
      let status = 'plus'
      // 加
      if (n == 1) {
        status = 'plus'
      }
      // 减
      if (n == this.pages2) {
        status = 'reduce'
      }
      if (status == 'plus') {
        n += 1
      } else {
        n -= 1
      }
      this.kQuery.pageNum = n
      this.getSearchTrendInfo()
    },
    // 找客商 收藏
    collectEvent_p(params, index, data) {
      params.collectionSubjectId = data.visitorId || data.id
      params.id = data.collectionId
      this.collectEvent(params, index)
    },
    // 找展商 收藏
    collectEvent_a(params, index, data) {
      params.collectionSubjectId = data.id
      params.id = data.collectionId
      this.collectEvent(params, index)
    },
    // 找展商 邀约
    inviteEvent_a(params, index, data) {
      data.exhibitorId = data.id
      data.exhibitorName = data.exhibitorName || data.name || data.atrName
      this.inviteEventExh(data, index, 'exhibitors')
    },
    // 找展商, 展品 消息
    message_a(data) {
      if (!data.exhibitorId) {
        data.exhibitorId = data.id
      }
      data.atrName = data.atrName || data.exhibitorName || data.name
      this.msgEventExh(data, null, this.identity === 'actor' ? 'exhibitors' : 'products')
    },
    // 找展商 直播
    live_a(data) {
      switch (this.identity) {
        // 展品
        case 'product':
          this.liveEvent(data.liveId)
          break
        // 展商
        case 'actor':
          this.liveEvent(data.liveId)
          break
      }
    },
    // 找客商 消息
    msgEvent(data, index) {
      data.id = data.visitorId
      data.psjName = data.visitorName
      data.psjRank = data.post
      data.psjComName = data.corporateName
      data.headPortrait = data.headImage
      this.msgEventPerson(data, index)
    },
    // 找客商 详情
    detailsEvent(data) {
      this.pageDetail(data, this.identity)
    },
    // 向前翻译
    pagePrev() {
      if (this.query.pageNum == 1) return
      this.query.pageNum -= 1
      this.fetchDataList()
    },
    // 向后翻页
    pageNext() {
      if (this.query.pageNum == this.pages) return
      this.query.pageNum += 1
      this.fetchDataList()
    },
    changeSort(sort, field, level) {
      window.PC.$RangersEventList('sort', field)
      const sortName = 'sort' + (level == 1 ? '' : level)
      switch (sort) {
        case 'desc':
          this[sortName] = 'asc'
          this.sortField = field + '_ASC'
          break
        case '':
          this[sortName] = 'desc'
          this.sortField = field + '_DESC'
          break
        case 'asc':
          this[sortName] = ''
          this.sortField = 'recommend_custom_letter_asc'
          break
      }
      switch(level) {
        case 1:
          this.sort2 = ''
          this.sort3 = ''
          break
        case 2:
          this.sort = ''
          this.sort3 = ''    
          break
        case 3:
          this.sort = ''
          this.sort2 = ''
          break
      }
      
      this.searchList()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import './../styles/pages/searchList'
</style>
